import React from 'react';
import Spinner from '../components/Spinner/Spinner';
import './FetchState.scss'

interface FetchStateProps{
    tilesCount?:number
    result?:'success'|'failure'
    progress?:boolean,
    goBack:()=>void

}

export const FetchState = (props:FetchStateProps)=>{
    const{tilesCount, result,progress,goBack}=props

    return <div className="lib-fetch">
        {result === 'failure'?<div className='lib-fetch__error'>Something went wrong!</div>:null}
        {result === 'failure'?<button onClick={goBack}>Go back</button>:null}
        {!tilesCount && progress ? <Spinner active container=''/>:null}
    </div>
}